import { NonEmptyArray, nonEmptyArrayOr } from '../../../../../../../../packages/JsonQuery';
import { SUBSIDIZED_MORTGAGE_OPTION_VALUE } from 'shared/constants/subsidizedMortgage';

export function removeSubsidizedMortgageFromValues(values: NonEmptyArray<string> | null) {
  if (!values) {
    return values;
  }

  const newPromoSearchTypeValues = values.filter(item => item !== SUBSIDIZED_MORTGAGE_OPTION_VALUE);

  return nonEmptyArrayOr(newPromoSearchTypeValues);
}
